// extracted by mini-css-extract-plugin
module.exports = {"text-gradient":"Property_text-gradient__1vKOR","item":"Property_item__ENKTG"};